<div class="dictation-demo">
    <h2>🎤 Voice Dictation Demo</h2>
    <p>Test the dictation functionality with these form fields. Click the microphone icon and start speaking!</p>

    <div class="demo-sections">
        <h3>🔥 NEW: Directive Approach (Just add dictationEnabled)</h3>
        <p>Simply add <code>dictationEnabled</code> to any input/textarea!</p>

        <!-- Directive Examples -->
        <div class="directive-examples">
            <!-- Mat Form Field with Directive -->
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Chief Complaint (Directive)</mat-label>
                <input matInput formControlName="chiefComplaint" placeholder="Describe the main concern..."
                    dictationEnabled [dictationContext]="'Chief Complaint'" [dictationPatientId]="'demo-patient'"
                    [dictationComponentName]="'DemoComponent'">
            </mat-form-field>

            <!-- Textarea with Directive -->
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Clinical Notes (Directive)</mat-label>
                <textarea matInput formControlName="clinicalNotes" placeholder="Enter clinical observations..." rows="3"
                    dictationEnabled [dictationContext]="'Clinical Notes'" [dictationPatientId]="'demo-patient'">
                </textarea>
            </mat-form-field>

            <!-- Standalone Input with Directive -->
            <div class="standalone-input-group">
                <label for="standaloneInput">Standalone Input (Directive):</label>
                <input type="text" id="standaloneInput" formControlName="standaloneField"
                    placeholder="Try dictation here..." dictationEnabled [dictationContext]="'Standalone Input'"
                    class="standalone-input">
            </div>
        </div>

        <h3>📊 Original Component Approach (For Comparison)</h3>

        <form [formGroup]="demoForm" class="demo-form">

            <!-- Patient Notes Field -->
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Patient Notes</mat-label>
                <textarea matInput formControlName="patientNotes" placeholder="Enter patient notes or use dictation..."
                    rows="4">
      </textarea>
                <app-dictation-button matSuffix [targetControl]="patientNotesControl"
                    (textReceived)="onDictationReceived($event, 'Patient Notes')"
                    (recordingStarted)="onRecordingStarted('Patient Notes')"
                    (recordingStopped)="onRecordingStopped('Patient Notes')">
                </app-dictation-button>
                <mat-error *ngIf="patientNotesControl.invalid && patientNotesControl.touched">
                    Patient notes are required
                </mat-error>
            </mat-form-field>

            <!-- Symptoms Field -->
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Symptoms</mat-label>
                <input matInput formControlName="symptoms" placeholder="Describe symptoms...">
                <app-dictation-button matSuffix [targetControl]="symptomsControl"
                    (textReceived)="onDictationReceived($event, 'Symptoms')"
                    (recordingStarted)="onRecordingStarted('Symptoms')"
                    (recordingStopped)="onRecordingStopped('Symptoms')">
                </app-dictation-button>
            </mat-form-field>

            <!-- Diagnosis Field -->
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Diagnosis</mat-label>
                <input matInput formControlName="diagnosis" placeholder="Enter diagnosis...">
                <app-dictation-button matSuffix [targetControl]="diagnosisControl"
                    (textReceived)="onDictationReceived($event, 'Diagnosis')"
                    (recordingStarted)="onRecordingStarted('Diagnosis')"
                    (recordingStopped)="onRecordingStopped('Diagnosis')">
                </app-dictation-button>
            </mat-form-field>

            <!-- Action Buttons -->
            <div class="form-actions">
                <button mat-raised-button type="button" (click)="clearForm()">
                    Clear Form
                </button>
                <button mat-raised-button color="primary" type="submit" [disabled]="demoForm.invalid">
                    Save (Demo)
                </button>
            </div>
        </form>

        <!-- Dictation Log -->
        <div class="dictation-log" *ngIf="dictationLog.length > 0">
            <div class="log-header">
                <h3>Dictation Log</h3>
                <button mat-icon-button (click)="clearLog()" title="Clear log">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
            <div class="log-entries">
                <div *ngFor="let entry of dictationLog; trackBy: index" class="log-entry">
                    {{ entry }}
                </div>
            </div>
        </div>

        <!-- Instructions -->
        <div class="instructions">
            <h4>Instructions:</h4>
            <ul>
                <li>🎤 Click the microphone icon next to any field</li>
                <li>🗣️ Start speaking clearly</li>
                <li>⏹️ Click the stop button or pause to finish</li>
                <li>✏️ Text will appear in the field automatically</li>
                <li>🔄 You can dictate multiple times to the same field</li>
            </ul>

            <div class="browser-note">
                <mat-icon>info</mat-icon>
                <span>Note: This demo uses your browser's built-in speech recognition. Chrome works best!</span>
            </div>
        </div>
    </div>